import { render, staticRenderFns } from "./ProcedureShareConfirm.vue?vue&type=template&id=9603516e&"
import script from "./ProcedureShareConfirm.vue?vue&type=script&lang=ts&"
export * from "./ProcedureShareConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports